var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.842041 31.927H32.5836V35.9179H0.842041V31.927ZM32.5836 0H0.842041V19.9544C0.842041 24.3643 4.39313 27.9361 8.77744 27.9361H20.6805C25.0648 27.9361 28.6159 24.3643 28.6159 19.9544V13.9681H32.5836C33.6359 13.9681 34.6451 13.5476 35.3892 12.7992C36.1333 12.0507 36.5513 11.0356 36.5513 9.97719V3.99088C36.5513 1.77594 34.7857 0 32.5836 0ZM24.6482 19.9544C24.6482 22.1494 22.8628 23.9453 20.6805 23.9453H8.77744C6.59521 23.9453 4.80974 22.1494 4.80974 19.9544V3.99088H24.6482V19.9544ZM32.5836 9.97719H28.6159V3.99088H32.5836V9.97719Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.995b943836d7df7edf99779d4c4e2b30.svg";
export { ForwardRef as ReactComponent };